const levelMap = {
  GOOD: 'Baik',
  WATCH: 'Perlu Pantau',
  DEGRADED: 'Menurun',
  CRITICAL: 'Kritis',
  LOW: 'Rendah',
  MEDIUM: 'Sedang',
  HIGH: 'Tinggi',
};

export const toExperienceLabel = (value) => levelMap[String(value || '').toUpperCase()] || String(value || '-');

export const sortByExperienceScoreDesc = (items = []) => [...items].sort((a, b) => Number(b?.experienceScore || 0) - Number(a?.experienceScore || 0));

export const formatScore = (value) => Number(value || 0).toFixed(1);

export const filterExperienceItems = (items = [], filters = {}) => {
  const area = String(filters.area || '').trim();
  const experienceLevel = String(filters.experienceLevel || '').trim();
  const complaintRisk = String(filters.complaintRisk || '').trim();
  const churnRisk = String(filters.churnRisk || '').trim();
  const outreachPriority = String(filters.outreachPriority || '').trim();

  return items.filter((item) => {
    if (area && String(item?.areaName || '') !== area) return false;
    if (experienceLevel && String(item?.experienceLevel || '') !== experienceLevel) return false;
    if (complaintRisk && String(item?.complaintRiskLevel || '') !== complaintRisk) return false;
    if (churnRisk && String(item?.churnRiskLevel || '') !== churnRisk) return false;
    if (outreachPriority && String(item?.outreachPriority || '') !== outreachPriority) return false;
    return true;
  });
};
